import React, { useState } from "react";
import { Button, Divider, Table, Tooltip, Segmented } from "antd";
import styles from "../styles/suppllierTable.module.css";
import { SyncOutlined } from "@ant-design/icons";
import { supplierTableCols } from "../utils/supplierTableUtils";
import ResizableTitle from "./resize";
import { PlusOutlined } from "@ant-design/icons";

export default function SupplierBody(props) {
  const {
    supplierListData,
    loading,
    totalRecords,
    onTableChange,
    currentPage,
    onRefresh,
    currentPageSize,
    onPaginationChange,
    setShowModal,
    onSupplierClicked,
    setIsEdit,
    activeFilter,
    onActiveFilterChange,
  } = props;
  const [columns, setColumns] = useState(
    supplierTableCols(onSupplierClicked, setShowModal)
  );

  const handleResize =
    (index) =>
    (_, { size }) => {
      const newColumns = [...columns];
      newColumns[index] = {
        ...newColumns[index],
        width: size.width,
      };
      setColumns(newColumns);
    };
  const mergeColumns = columns.map((col, index) => ({
    ...col,
    onHeaderCell: (column) => ({
      width: column.width,
      onResize: handleResize(index),
      minWidth: column.minWidth,
    }),
  }));

  return (
    <>
      <div>
        <div style={{ marginBottom: "16px", display: "flex", justifyContent: "flex-start" }}>
          <Segmented
            options={[
              { label: "All", value: "all" },
              { label: "Active", value: "active" },
              { label: "Inactive", value: "inactive" },
            ]}
            value={activeFilter}
            onChange={onActiveFilterChange}
          />
        </div>
        <div className={styles.containerHeader}>
          <div className={styles.containerHeaderCol1}>
            <span style={{ fontWeight: "bold" }}>Suppliers</span>{" "}
            <span className={styles.containerHeaderCol1Span}>
              ({totalRecords})
            </span>
          </div>
          <div className={styles.containerHeaderCol2}>
            <Tooltip title="Refresh">
              <Button
                icon={<SyncOutlined spin={loading} tool />}
                onClick={onRefresh}
                disabled={loading}
              />
            </Tooltip>
            <Divider type="vertical" />
            <Tooltip>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setShowModal(true);
                  setIsEdit(false);
                }}
              >
              </Button>
            </Tooltip>
          </div>
        </div>
        <div className={styles.containerBody}>
          <Table
            bordered
            loading={loading}
            size="small"
            onChange={onTableChange}
            columns={mergeColumns}
            dataSource={supplierListData}
            pagination={{
              pageSize: currentPageSize,
              total: totalRecords,
              current: currentPage,
              showSizeChanger: true,
              onChange: onPaginationChange,
            }}
            components={{
              header: {
                cell: ResizableTitle,
              },
            }}
            scroll={{ x: 1200, y: 500 }}
          />
        </div>
      </div>
    </>
  );
}
